import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../components/Logo';
import { CheckCircle2 } from 'lucide-react';

export default function PendingApproval() {
    const loc = useLocation();
    const mobile = loc.state?.mobile;
    return (
        <div className="min-h-screen bg-sdf-ivory">
            <div className="px-4 py-6 flex items-center justify-center border-b border-sdf-line"><Logo variant="login" /></div>
            <main className="max-w-md mx-auto px-4 py-14 text-center">
                <CheckCircle2 size={64} className="mx-auto text-green-600" />
                <h1 className="mt-4 text-2xl font-extrabold text-sdf-text">Registration Received</h1>
                <p className="mt-3 text-sm text-sdf-text-2">
                    Thank you! Your registration{mobile ? <> for <span className="font-bold text-sdf-text">+91 {mobile}</span></> : ''} is under review by our admin team.
                    You&apos;ll be able to log in via mobile + OTP once approved.
                </p>
                <Link to="/login" className="btn-red mt-6 inline-flex">Back to Sign In</Link>
            </main>
        </div>
    );
}
